export interface MeterBarLayoutProvidersProps {
  providerName: unknown;
  providerProps: Record<string, unknown>;
}

export const Providers = (_: MeterBarLayoutProvidersProps) => {
  return null;
};

Providers['displayName'] = 'MeterBarLayout.Providers';
